angular.module('satv.track', [
    'ngResource',
    'satv.loader'
    ],function($interpolateProvider) {
    $interpolateProvider.startSymbol('[[');
    $interpolateProvider.endSymbol(']]');
})

.constant('config',  app_config)

;



// WEBPACK FOOTER //
// ./vendor/sonyatv/smfcoreclientbundle/Resources/js/angular/module.js